import { render, staticRenderFns } from "./StoreSummaryMobile.vue?vue&type=template&id=be37fb36"
import script from "./StoreSummaryMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreSummaryMobile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StoreSummaryMobile.vue?vue&type=style&index=0&id=be37fb36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports